app.component("eyeSection", {
	templateUrl: "app/src/js/components/operationNote/eyeSection/eyeSection.html",
	controller: "eyeSectionController",
	bindings: {
		data: "<",
		eyeTitle: "@",
		otherTypeSetting: "<",
		setDefaultMedications: "&",
		refreshProcedure: "&",
		favoriteProcedureList: "<",
	},
});

app.controller("eyeSectionController", [
	"$scope",
	"Session",
	"OPERATIONPROCEDURE",
	"OPERATIONANAESTHETIC",
	"INCISIONSIZE",
	"OVD",
	"OP_NOTE_EYE_BANK_FORM",
	"OPNOTE_SAVE_OTHER_PROCEDURE_1296",
	"OperationAPI",
	"OperationNote",
	function ($scope, Session, OPERATIONPROCEDURE, OPERATIONANAESTHETIC, INCISIONSIZE, OVD, OP_NOTE_EYE_BANK_FORM,OPNOTE_SAVE_OTHER_PROCEDURE_1296,OperationAPI,OperationNote) {
		$scope.operationProcedure = OPERATIONPROCEDURE;
		$scope.anaesthetic = OPERATIONANAESTHETIC;
		$scope.incisionSize = INCISIONSIZE.map((t) => t);
		$scope.warn = false;
		$scope.otherOvdArray = [];
		$scope.warn_ovd = false;

		$scope.API = OperationAPI;

		$scope.operationNoteData = OperationNote;

		$scope.state = { isProcessing: false };

		$scope.savedProcedureFeatureEnabled = OPNOTE_SAVE_OTHER_PROCEDURE_1296;


		$scope.removeIncision = function (index) {
			$scope.$ctrl.data.incisions.splice(index, 1);
		};

		$scope.removeOther = function (index) {
			$scope.otherOvdArray.splice(index, 1);
			syncOtherOvd();
		};

		// The free-text OVDs live in the "Other" slot of data.ovd as one comma-joined string, so it
		// has to be rebuilt whenever that list changes - otherwise a removed entry is still saved.
		function syncOtherOvd() {
			if (!$scope.$ctrl.data) {
				return;
			}
			$scope.$ctrl.data.ovd = $scope.selection.map(function (item) {
				if (item === "Other" && $scope.otherOvdArray.length > 0) return getOtherOvdArrayString($scope.otherOvdArray);
				return item;
			});
		}

		$scope.selection = [];
		// if($scope.$ctrl.data.ovd){
		// 	$scope.selection = $scope.$ctrl.data.ovd;
		// }

		const transformSavedProcedures = (favoriteProcedureList) => {
			$scope.savedProcedures = angular.copy(favoriteProcedureList ?? []).map((item, index) => {
				return { value: item, key: index };
			});
		};

		this.$onInit = function () {
			transformSavedProcedures($scope.$ctrl.favoriteProcedureList);
			$scope.data = { selected_procedure: null };

			$scope.clinicianLabel = "You"
		};

		$scope.onProcedureChange = function () {
			if ($scope.$ctrl.data.procedure_type !== "OTHER") {
				$scope.$ctrl.data.other_procedure = null;
				$scope.data.selected_procedure = null;
			}
			if ($scope.$ctrl.refreshProcedure) {
				$scope.$ctrl.refreshProcedure();
			}
		};

		this.$onChanges = function (changesObj) {
			if (changesObj.data?.currentValue) {
				$scope.OVD = $scope.OVD.map((t) => ({ ...t, selected: false }));
				$scope.otherOvdArray = [];
				if (changesObj.data.currentValue.ovd && changesObj.data.currentValue.ovd.length > 0) {
					changesObj.data.currentValue.ovd.forEach((element) => {
						const obj = $scope.OVD.find((t) => t.value === element);
						if (obj) {
							obj.selected = true;
						} else {
							$scope.OVD.find((t) => t.value === "Other").selected = true;
							$scope.otherOvdArray = element.split(",");
							// $scope.otherOvd = element;
						}
					});
				}
				// else if(changesObj.data.currentValue.ovd){
				// 	$scope.OVD = OVD.map(t => ({...t, selected: false}));
				// 	$scope.otherOvdArray = [];
				// }
			}
		};

		$scope.$watch(
			"OVD|filter:{selected:true}",
			function (newValue) {
				$scope.selection = newValue.map(function (item) {
					return item.value;
				});
				if ($scope.$ctrl.data) {
					$scope.$ctrl.data.ovd = $scope.selection.map(function (item) {
						if (item === "Other") {
							$scope.warn_ovd = false;
						}
						if (item === "Other" && $scope.otherOvdArray.length > 0) return getOtherOvdArrayString($scope.otherOvdArray);
						return item;
					});
				}
			},
			true,
		);  

		$scope.$watch(
			"operationNoteData",
			function (newValue) {
				if(newValue){
					$scope.clinicianLabel = Session.user.id === newValue.setting?.user_id ? 'You' : 'The clinician'
				}
			},
			true,
		); 
		
		$scope.$watch(
			"$ctrl.favoriteProcedureList",
			function (newValue) {
				transformSavedProcedures(newValue ?? []);
			},
			true,
		);

		function getOtherOvdArrayString(array) {
			let str = "";
			array.forEach((element, index) => {
				str = str + element;
				if (index !== array.length - 1) {
					str = str + ",";
				}
			});
			return str;
		}

		$scope.form_other = { value: "" };

		$scope.addOther = function () {
			if ($scope.form_other.value && $scope.form_other.value.length > 2 && $scope.form_other.value.length < 41) {
				$scope.otherOvdArray.push($scope.form_other.value);
				$scope.$ctrl.data.ovd = $scope.selection.map(function (item) {
					if (item === "Other") return getOtherOvdArrayString($scope.otherOvdArray);
					return item;
				});
				$scope.warn_ovd = false;
				$scope.form_other.value = "";
			}
		};

		$scope.OVD = OVD.map((t) => ({ ...t, selected: false }));

		$scope.addIncision = function () {
			if (
				!$scope.$ctrl.form.incision_size.val ||
				!$scope.$ctrl.form.incision_enlargement ||
				(!$scope.$ctrl.form.incision_location_degree && $scope.$ctrl.form.incision_location_degree !== 0) ||
				!$scope.$ctrl.form.incision_location
			) {
				return;
			}
			let size, enlargement, location_degree, location;
			try {
				size = $scope.$ctrl.form.incision_size.val;
				enlargement = $scope.$ctrl.form.incision_enlargement;
				location_degree = $scope.$ctrl.form.incision_location_degree;
				location = $scope.$ctrl.form.incision_location;
			} catch (error) {
				return;
			}

			if (!$scope.$ctrl.data.incisions) {
				$scope.$ctrl.data.incisions = [];
			}
			$scope.$ctrl.data.incisions.push({
				size: size ? Number.parseFloat(size.id).toFixed(1) : null,
				enlargement,
				location_degree,
				location_type: location,
			});
			// reset fields to empty
			this.$ctrl.form.incision_size.val = null;
			// this.$ctrl.form.incision_enlargement = null;
			this.$ctrl.form.incision_location_degree = null;
			$scope.warn = false;
			// this.$ctrl.form.incision_location = null;
		};
		$scope.onChange = function () {
			if (angular.isString($scope.$ctrl.form.incision_size.val)) {
				$scope.$ctrl.form.incision_size.val = {
					id: $scope.$ctrl.form.incision_size.val,
					name: $scope.$ctrl.form.incision_size.val,
				};
				if (!$scope.incisionSize.find((t) => t.name === $scope.$ctrl.form.incision_size.val.name)) {
					$scope.incisionSize.push($scope.$ctrl.form.incision_size.val);
				}
			}
			$scope.showWarn();
			// $scope.$ctrl.data.ccc.pupil_expander = $scope.$ctrl.freeTextDemo.val.id;
		};

		$scope.showWarn = function () {
			$scope.warn = true;
		};

		$scope.showWarn_ovd = function () {
			$scope.warn_ovd = true;
		};

		const mergeDefaultSettings = (obj) => {
			$scope.$ctrl.data.other_procedure.description = obj.description;
			$scope.$ctrl.data.anaesthetic = obj.anaesthetic;
			$scope.$ctrl.data.instructions_for_patient = obj.instructions_for_patient;
			$scope.$ctrl.data.intraoperative_medications = obj.intraoperative_medications;

			if ($scope.$ctrl.setDefaultMedications) {
				const result = {
					medications: obj.postop_medications,
					care: obj.postop_care,
					eyes: $scope.$ctrl.eyeTitle
				}
				$scope.$ctrl.setDefaultMedications({ result });
			}
		}

		$scope.primaryProcedureCallback = function (form) {
			if (!$scope.$ctrl.data.other_procedure) {
				$scope.$ctrl.data.other_procedure = {};
			}
			if (!form.diagnosis_object) {
				$scope.$ctrl.data.other_procedure.primary_procedure = null;
				return;
			}
			$scope.$ctrl.data.other_procedure.primary_procedure = {
				...form.diagnosis_object,
				concept_id: form.diagnosis_object.concept_id,
			};

			const isFavourite = form.isFavourite;

			if (isFavourite && form.secondary_procedure_list) {
				$scope.$ctrl.data.other_procedure.secondary_procedure_list = angular.copy(form.secondary_procedure_list);
				const obj = findExactCombination();
				if (obj) {
					mergeDefaultSettings(obj);
				}
				return;
			}

			const obj = findExactCombination();

			if (obj) {
				$scope.$ctrl.data.other_procedure.secondary_procedure_list = angular.copy(obj.secondary_procedure_list);
				mergeDefaultSettings(obj);
			} else {
				$scope.$ctrl.data.other_procedure.secondary_procedure_list = [];
				$scope.$ctrl.data.other_procedure.description = null;
				$scope.$ctrl.data.anaesthetic = null;
				$scope.$ctrl.data.instructions_for_patient = null;
				$scope.$ctrl.data.intraoperative_medications = null;
			}
		};

		function areArraysEqual(a, b) {
			if (a.length !== b.length) {
				return false;
			}

			const bIds = new Set(b.map(item => item.concept_id));

			return a.every(item => bIds.has(item.concept_id));
		}

		const findExactCombination = () => {
			const obj = $scope.$ctrl.otherTypeSetting.find((t) => t.primary_procedure?.concept_id === $scope.$ctrl.data.other_procedure.primary_procedure?.concept_id &&
				areArraysEqual(t.secondary_procedure_list ?? [], $scope.$ctrl.data.other_procedure.secondary_procedure_list ?? []));
			return obj;
		}

		$scope.secondaryProcedureCallback = function (form) {
			if (!$scope.$ctrl.data.other_procedure) {
				$scope.$ctrl.data.other_procedure = { secondary_procedure_list: [] };
			} else if (!$scope.$ctrl.data.other_procedure.secondary_procedure_list) {
				$scope.$ctrl.data.other_procedure.secondary_procedure_list = [];
			}
			if (form) {
				const array = form.map((t) => ({ ...t, concept_id: t.concept_id }));
				$scope.$ctrl.data.other_procedure.secondary_procedure_list = array;
			}
			const result = findExactCombination(form);
			if (result) {
				mergeDefaultSettings(result);
			}
		};

		$scope.shouldHide = (primary_procedure) => {
			if (primary_procedure && OP_NOTE_EYE_BANK_FORM.some((t) => t.value === primary_procedure.concept_id)) {
				return true;
			}
			return false;
		};

		$scope.$watch(
			"data.selected_procedure",
			function (newValue) {
				if (!$scope.$ctrl.data.other_procedure) {
					$scope.$ctrl.data.other_procedure = {};
				}
				if(!newValue){
					return;
				}
				$scope.$ctrl.data.other_procedure.primary_procedure = angular.copy(newValue.primary_procedure);
				$scope.$ctrl.data.other_procedure.secondary_procedure_list = angular.copy(newValue.secondary_procedure_list);
	
			},
			true,
		);

		function arraysAreSame(a, b) {
			if (a.length !== b.length) return false;
			return a.every((item, index) => item.concept_id === b[index].concept_id);
		}

		$scope.$watch(
			"$ctrl.data.other_procedure",
			function (newValue) {
				if (!newValue) {
					return;
				}
				//check 'buttonState'
				$scope.buttonState = "";

				const primary_procedure = newValue.primary_procedure;
				if(!primary_procedure){
					return;
				}
				const secondary_procedure_list = newValue.secondary_procedure_list ?? [];

				const targetPrimary = $scope.savedProcedures.find(
					(item) => item.value.primary_procedure?.concept_id === primary_procedure.concept_id,
				);

				if (primary_procedure && targetPrimary) {
					const same = arraysAreSame(secondary_procedure_list, targetPrimary.value.secondary_procedure_list ?? []);
					if (same) {
						$scope.buttonState = "SAVED";
					}
				}
			},
			true,
		);

		// $scope.saveFavouriteProcedure = () => {
		// 	// add new favourite procedure collection
		// 	const setting = OperationNote.setting.op_note_settings ?? {};
		// 	const primary_procedure = $scope.$ctrl.data.other_procedure.primary_procedure;
		// 	const secondary_procedure_list = $scope.$ctrl.data.other_procedure.secondary_procedure_list;
		// 	const favorite_procedure_list = [
		// 		...setting.favorite_procedure_list ?? [],
		// 		{
		// 			primary_procedure,
		// 			secondary_procedure_list,
		// 		},
		// 	];
		// 	const payload = {
		// 		...OperationNote.setting,
		// 		op_note_settings: { ...setting, favorite_procedure_list },
		// 	};
		// 	$scope.state.isProcessing = true;
		// 	$scope.API.saveFavouriteProcedure(payload)
		// 		.then(function (resp) {
		// 			transformSavedProcedures(resp.data.op_note_settings.favorite_procedure_list);
		// 			$scope.buttonState = "SAVED";
		// 		})
		// 		.then(() => ($scope.state.isProcessing = false));
		// };

		$scope.deleteFavouriteProcedure = function (item) {
			if (!OperationNote.setting) {
				return;
			}
			const setting = OperationNote.setting.op_note_settings ?? {};
			// Build from the list on screen: item.key indexes savedProcedures, which is refreshed
			// after every delete, whereas the cached setting's list would still hold earlier deletions.
			const favorite_procedure_list = ($scope.savedProcedures ?? [])
				.filter((t) => t.key !== item.key)
				.map((t) => t.value);
			const payload = {
				...OperationNote.setting,
				op_note_settings: { ...setting, favorite_procedure_list },
			};
		
			$scope.state.isProcessing = true;
			$scope.API.saveFavouriteProcedure(payload)
				.then(function (resp) {
					OperationNote.setDefaultSetting(resp.data);
					transformSavedProcedures(resp.data.op_note_settings.favorite_procedure_list);
				})
				.catch(function (error) {
					console.error("delete favourite procedure failed", error && error.status);
				})
				.finally(() => ($scope.state.isProcessing = false));
		};
	},
]);
